var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}check-24`,"viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"base",attrs:{"cx":"12","cy":"12","r":"12"}}),_c('path',{staticClass:"sign",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.7072 11.2072L11.5001 15.4143L8.29297 12.2072L9.70718 10.793L11.5001 12.5859L14.293 9.79297L15.7072 11.2072Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }